import React from 'react';
import PreviewCompatibleImage from './PreviewCompatibleImage';
import { Link } from 'gatsby';

export const Gift = ({ title, description, price, discount_price, image, slug }) => (
  <Link className="card" to={slug}>
    <div className="card-image">
      <PreviewCompatibleImage imageInfo={image} />
    </div>
    <div className="card-content">
      <div className="content">
        <h3 className="title is-5">{title}</h3>
        <p>{description}</p>
        {(discount_price || price) && (
          <h4>
            {discount_price ? (
              <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '80%' }}>
                {price}
              </span>
            ) : null}{' '}
            {discount_price ? discount_price : price} <small>рублей</small>
          </h4>
        )}
      </div>
    </div>
  </Link>
);
